/* eslint-disable react/no-danger */
import React from 'react';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { ERROR_DATA } from '@/constants/errorTable';
import { getCurrentCountry } from '@/utils/domain';

function ErrorTable() {
  const { t } = useTranslation();

  // to get the current country
  const country = getCurrentCountry();

  // Removing the SENDER_ID_REQUIRED according to the country
  const filteredError =
    country === 'br'
      ? ERROR_DATA.filter((item) => item.code !== 'SENDER_ID_REQUIRED')
      : ERROR_DATA;

  // Map through the filtered array to update the 'no' property
  const updatedArray = filteredError.map((error, index) => ({
    ...error,
    no: index + 1,
  }));

  return (
    <div className="error-table">
      <div className="api-document__content__title">
        {t('api_page.documents.error_table.title')}
      </div>

      <Card className="error-table__card">
        <div className="error-table__card__group --header">
          <span className="error-table__card__header --no">
            {t('api_page.documents.api_detail.table.error_no')}
          </span>
          <span className="error-table__card__header">
            {t('api_page.documents.api_detail.table.HTTP_status_code')}
          </span>
          <span className="error-table__card__header --desc">
            {t('api_page.documents.api_detail.table.description')}
          </span>
        </div>
        {updatedArray.map(({ no, code, desc }) => {
          const bgKlass = no % 2 === 0 ? '--bg-gray' : '';
          return (
            <div key={no} className={`error-table__card__group ${bgKlass}`}>
              <span className="error-table__card__value --no">{no}</span>
              <span className="error-table__card__value">{code}</span>
              <span
                className="error-table__card__value --desc"
                dangerouslySetInnerHTML={{
                  __html: desc,
                }}
              />
            </div>
          );
        })}
      </Card>
    </div>
  );
}

export default ErrorTable;
